import React from 'react';
import './CardButton.css';
import { directDeepLink, SOURCE_HOME } from '../../../util';
import { useHistory } from 'react-router-dom';


function CardButton({text, subtext = '', className, deeplink = '', navigate, eventCallback = null}) {
	let history = useHistory();
	return (
		<button className={className} onClick={() => {
			// window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(deeplink));
			if(typeof eventCallback === "function") {
				eventCallback();
			}
			deeplink && directDeepLink(deeplink, SOURCE_HOME);
			navigate && history.push(navigate)}}>
			{text}
			{subtext && (
				<span className='card-btn-subtext'>{subtext}</span>
			)}
		</button>
	);
}
export default CardButton;
